import { executeRequest, HTTP_METHODS } from "@/common/utils/http/httpClient";

export async function getCards() {
  return await executeRequest(
    {
      url: `/assets/mocks/cards.json`,
      method: HTTP_METHODS.GET
    },
    false
  );
}
